import React from 'react'

import CreatePartsTransferForm from '../../CreatePartsTransferForm'

export type TransferPartsModalProps = {
	onCancel: () => void,
	onSuccess: () => void,
}

export default function TransferPartsModal( props: TransferPartsModalProps ) {
	return (
		<CreatePartsTransferForm
			{...props}
		/>
	)
}
